import React, { useEffect, useState } from "react";
import { PGET } from "../../../api/adminApi";
import { Card, Col, Row, Statistic } from "antd";
import {
  FaArrowDown,
  FaBox,
  FaBuilding,
  FaChartLine,
  FaCoins,
  FaDollarSign,
  FaIndustry,
  FaUserCheck,
  FaUserFriends,
  FaUserTie,
} from "react-icons/fa";
import moment from "moment/moment";
import CustomDatePicker from "../../common/CustomDatePicker";

export default function Statistics() {
  const [items, setItems] = useState([]);
  const currentYear = new Date();
  currentYear.setMonth(0, 1); // January 1st of current year
  const nextYear = new Date();
  nextYear.setFullYear(nextYear.getFullYear() + 1);
  nextYear.setMonth(0, 1); // January 1st of next year
  const [dateRange, setDateRange] = useState([currentYear, nextYear]);
  const [startDate, endDate] = dateRange;

  async function getItems() {
    const payload = {};
    if (startDate && endDate) {
      payload.dateFrom = moment(startDate).format("YYYY-MM-DD");
      payload.dateTo = moment(endDate).add(1, "day").format("YYYY-MM-DD");
    }
    const data = await PGET("/services/admin/api/dashboard-counts/", true, payload);
    if (data) {
      setItems(data.data);
    }
  }

  useEffect(() => {
    getItems();
  }, [startDate, endDate]);

  const colors = {
    salesManger: "#6A5DFF",
    registeredSalesManger: "#57CC99", // Soft green
    productCount: "#FFA69E", // Muted coral
    salesPanel: "#D4A5A5", // Dusty pink
    salesSection: "#A5D8D6", // Light teal
    salesKotel: "#DAB785", // Warm sand
    pointsTotal: "#9E9E9E", // Neutral gray
    usedPointsTotal: "#A78BFA", // Soft lavender
  };

  return (
    <div style={{ width: "100%" }}>
      <Row gutter={[16, 16]} style={{ marginBottom: "1rem" }}>
        <Col span={24}>
          <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "8px" }}>
            <div className="mr-2">
              <CustomDatePicker
                startDate={startDate}
                endDate={endDate}
                onChange={(update) => setDateRange(update)}
                className="datepicker-custom-input-dash"
              />
            </div>
          </div>
        </Col>
      <Col span={6}>
        <Card>
          <Statistic
            title="Продавцы"
            value={items.salesMangerCount}
            precision={0}
            valueStyle={{ color: colors.salesManger }}
            prefix={<FaUserTie />}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <Statistic
            title="Зарег. продавцы"
            value={items.registeredSalesMangerCount}
            precision={0}
            valueStyle={{ color: colors.registeredSalesManger }}
            prefix={<FaUserCheck />}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <Statistic
            title="Актив продавцы"
            value={items.activeSalesMangerCount}
            precision={0}
            valueStyle={{ color: colors.productCount }}
            prefix={<FaUserFriends />}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <Statistic
            title="Панел. продажа"
            value={items.salesPanelCount}
            precision={0}
            valueStyle={{ color: colors.salesPanel }}
            prefix={<FaChartLine />}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <Statistic
            title="Секц. продажа"
            value={items.salesSectionCount}
            precision={0}
            valueStyle={{ color: colors.salesSection }}
            prefix={<FaBuilding />}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <Statistic
            title="Котел продажа"
            value={items.salesKotelCount}
            precision={0}
            valueStyle={{ color: colors.salesKotel }}
            prefix={<FaIndustry />}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <Statistic
            title="Набр. баллы"
            value={items.pointsTotal}
            precision={0}
            valueStyle={{ color: colors.pointsTotal }}
            prefix={<FaCoins />}
          />
        </Card>
      </Col>
      <Col span={6}>
        <Card>
          <Statistic
            title="Исп. баллы"
            value={items.usedPointsTotal}
            precision={0}
            valueStyle={{ color: colors.usedPointsTotal }}
            prefix={<FaDollarSign />}
          />
        </Card>
      </Col>
      </Row>
    </div>
  );
}
